import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import Link from 'components/Link'
import FacebookShare from 'components/FacebookShare'
import Container from 'layouts/Container'

import PngKlarna from 'assets/klarna.png'
import PngSting from 'assets/sting.png'
import PngVerifiera from 'assets/verifiera.png'

import {
  PARENT_SIGNUP as ROUTE_PARENT_SIGNUP,
  LEADER_SIGNUP as ROUTE_LEADER_SIGNUP,
} from 'views/Signup/constants'

import { reverse, filterLinks } from 'utilities/routes'

import styles from './styles.css'

class Footer extends Component {
  static propTypes = {
    className: PropTypes.string,
    account: PropTypes.oneOfType([
      PropTypes.bool.isRequired,
      PropTypes.object.isRequired,
    ]),
  }

  static defaultProps = {
    className: '',
    account: false,
  }

  static links = [
    {
      label: 'Bli ledare',
      href: reverse(ROUTE_LEADER_SIGNUP),
      exceptRole: 'leader',
    },
    {
      label: 'Registrera dig som förälder',
      href: reverse(ROUTE_PARENT_SIGNUP),
      auth: false,
    },
    {
      label: 'Så funkar det',
      href: reverse('static/sa-funkar-det'),
    },
    {
      label: 'Om oss',
      href: reverse('static/om-oss'),
    },
    {
      label: 'Frågor & svar',
      href: reverse('static/fragor-och-svar'),
    },
    {
      label: 'Allmänna villkor',
      href: reverse('static/allmanna-villkor'),
    },
    {
      label: 'Kontakt',
      href: reverse('static/kontakt'),
    },
  ]

  getClassName() {
    return classnames(styles.root, this.props.className)
  }

  render() {
    const { account } = this.props

    return (
      <footer className={this.getClassName()}>
        <Container size="large">
          <nav className={styles.nav}>
            <div className={styles.navContainer}>
              {filterLinks(Footer.links, account).map(link => (
                <Link key={link.href.type} href={link.href}>
                  {link.label}
                </Link>
              ))}
              <FacebookShare className={styles.facebookButton} />
            </div>
          </nav>
          <div className={styles.extra}>
            <div>
              <div>
                <strong>friendtivity&trade;</strong>
              </div>
              Org. 559117-6200 – Jungfrugatan 47, 114 44 Stockholm
            </div>
            <div className={styles.logos}>
              <a
                href="https://sting.co/sting-bolag/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src={PngSting} alt="Sting" style={{ height: 44 }} />
              </a>

              <a>
                <img src={PngKlarna} alt="Klarna" style={{ height: 29 }} />
              </a>

              <a
                href="https://verifiera.se/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src={PngVerifiera}
                  alt="Verifiera"
                  style={{ height: 44 }}
                />
              </a>
            </div>
          </div>
        </Container>
      </footer>
    )
  }
}

export default Footer



// WEBPACK FOOTER //
// ../source/layouts/Footer/index.js